import { render, staticRenderFns } from "./BuyThanks.vue?vue&type=template&id=a7766756&scoped=true&"
import script from "./BuyThanks.vue?vue&type=script&lang=js&"
export * from "./BuyThanks.vue?vue&type=script&lang=js&"
import style0 from "./BuyThanks.vue?vue&type=style&index=0&id=a7766756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7766756",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/buy_thanks.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FBuyThanks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports